import BasePage from './Page';

// EXPORT
export const Page = BasePage;
export type { PageProps } from './Page.interface';
